
export const leadSourceOptions = [
  { value: "Word of Mouth", label: "Word of Mouth" },
  { value: "Website", label: "Website" },
  { value: "Facebook", label: "Facebook" },
  { value: "Instagram", label: "Instagram" },
  { value: "LinkedIn", label: "LinkedIn" },
  { value: "Social Media", label: "Social Media (Other)" },
  { value: "Google", label: "Google" },
  { value: "Car Branding", label: "Car Branding" },
  { value: "House Branding", label: "House Branding" },
  { value: "Other", label: "Other (Unspecified)" },
];
